import { ManagerBase } from '@core/ManagerBase';
import type { IAdManager } from '@core/interfaces';

/** Reklam yönetimi — Phase 6+ implementasyon */
export class AdManager extends ManagerBase implements IAdManager {
  protected onInitialize(): void {
    // Phase 6
  }

  protected onShutdown(): void {
    // Phase 6
  }
}
